const kitchenDiningSurveyForm = {
  id: "kitchen_dining",
  title: "Kitchen cum Dining Survey",
  description:
    "Canteen (Kitchen cum Dining facility) wise Detailed Information should be furnished",

  sections: [
    {
      id: "a",
      title: "General Information (A)",
      questions: [
        {
          id: "A.1",
          label: "A.1",
          question:
            "Whether Canteen remains functional everyday including on holidays. If NO, specify the reason in the remark coloumn for non functioning everyday.",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          helperText: "",
          fields: [
            {
              id: "remark",
              type: "textarea",
              label: "Remarks",
              placeholder: "Enter remarks",
              showWhen: ["no"],
            },
          ],
        },
        {
          id: "A.2",
          label: "A.2",
          question:
            "Whether Canteen is operated by SHGs or others. If others, mention in the remark coloumn who are operating and specify the reason for non-engagement of SHGs.",
          type: "radio",
          options: [
            { label: "SHGs", value: "shgs" },
            { label: "Others", value: "others" },
          ],
          fields: [
            {
              id: "remark",
              type: "textarea",
              label: "Remarks",
              placeholder: "Enter remarks",
              showWhen: ["others"],
            },
          ],
        },
        {
          id: "A.3",
          label: "A.3",
          question:
            "Mention the number of Cook Cum Helpers engaged in the functioning of MAA Canteen",
          type: "number",
          options: [],
          helperText: "",
          fields: [],
        },
        {
          id: "A.4",
          label: "A.4",
          question: "Timing for service of meal",
          type: "time-range",
          options: [],
          helperText: "Guideline Stated Timing from 12 NOON to 3 PM",
          fields: [
            {
              id: "from",
              type: "time",
              label: "From",
              showWhen: [],
            },
            {
              id: "to",
              type: "time",
              label: "To",
              showWhen: [],
            },
          ],
        },
        {
          id: "A.5",
          label: "A.5",
          question: "Average Number of beneficiaries benefitted per DAY",
          type: "number",
          options: [],
          helperText: "",
          fields: [],
        },
        {
          id: "A.6",
          label: "A.6",
          question: "Whether receipt of Food Coupons preserved at ULB level for future reference and Audit purpose",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          fields: [],
        },
      ],
    },

    {
      id: "b",
      title: "Quality & Quantity Assessment of Served Food (B)",
      questions: [
        {
          id: "B.1",
          label: "B.1",
          question: "How would you rate the quality of the meal served?",
          type: "radio",
          options: [
            { label: "Good", value: "good" },
            { label: "Satisfactory", value: "satisfactory" },
            { label: "Poor", value: "poor" },
          ],
          helperText: "",
          fields: [],
        },
        {
          id: "B.2",
          label: "B.2",
          question: "How would you rate the quantity of meal served",
          type: "radio",
          options: [
            { label: "Good", value: "good" },
            { label: "Satisfactory", value: "satisfactory" },
            { label: "Poor", value: "poor" },
          ],
          helperText: "",
          fields: [],
        },
        {
          id: "B.3",
          label: "B.3",
          question: "Are all specified items (ie. Rice, Dal, Sabji and One full Tabled egg) being served everyday",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          helperText: "",
          fields: [],
        },
      ],
    },

    {
      id: "c",
      title: "Water Supply & Quality Checking (C)",
      questions: [
        {
          id: "C.1",
          label: "C.1",
          question: "Is there an adequate water storage capacity in canteen (≥45 L per head/day) for 2 days",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
            { label: "NA", value: "na" },
          ],
          helperText: "",
          fields: [],
        },
        {
          id: "C.2",
          label: "C.2",
          question: "Is a water filter installed to ensure safe drinking water for canteen staff and beneficiaries?",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          helperText: "",
          fields: [],
        },
        {
          id: "C.3",
          label: "C.3",
          question:
            "Are overhead/underground water tanks cleaned in every six months, with records maintained?",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
            { label: "NA", value: "na" },
          ],
          helperText: "Please mention the last date of tank cleaning and upload the picture of the tank cleaning with date printed",
          fields: [
            {
              id: "date",
              type: "date",
              label: "Last tank cleaning date",
              showWhen: ["yes"],
            },
            {
              id: "photo",
              type: "file",
              label: "Capture or upload photo",
              accept: "image/*",
              capture: "environment",
              showWhen: ["yes"],
            },
          ],
        },
        {
          id: "C.4",
          label: "C.4",
          question:
            "Is chemical and bacteriological testing of water conducted in every six months, with records maintained?",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
            { label: "NA", value: "na" },
          ],
          helperText: "Please mention the last date of the water quality testing and upload the corresponding test report.",
          fields: [
            {
              id: "date",
              type: "date",
              label: "Last water quality testing date",
              showWhen: ["yes"],
            },
            {
              id: "report",
              type: "file",
              label: "Upload Document",
              accept: "image/*",
              capture: "environment",
              showWhen: ["yes"],
            },
          ],
        },
      ],
    },

    {
      id: "d",
      title: "Kitchen & Dining Space (D)",
      questions: [
        {
          id: "D.1",
          label: "D.1",
          question:
            "Is the open kitchen adequately covered on all sides and have an overhead shed to prevent the entry of dirt, dust, and pests?",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          fields: [],
        },
        {
          id: "D.2",
          label: "D.2",
          question:
            "Is there a functional sink inside the kitchen area for canteen staff?",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          helperText: "Functional sink must have running water, soap for handwash, proper tap, proper outlet pipe and connected to a drainage system. [If all the above conditions are available, respond YES]",
          fields: [
            {
              id: "photo",
              type: "file",
              label: "Capture or upload photo",
              accept: "image/*",
              capture: "environment",
              showWhen: ["yes"],
            },
          ],
        },
        {
          id: "D.3",
          label: "D.3",
          question:
            "Is there a functional handwashing station in the dining area for beneficiaries?",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          helperText: "Functional handwashing station must have running water, soap for handwash, proper tap, covered area with outlet pipe and connected to a drainage system. (If all the above conditions are available respond YES)",
          fields: [
            {
              id: "photo",
              type: "file",
              label: "Capture or upload photo",
              accept: "image/*",
              capture: "environment",
              showWhen: ["yes"],
            },
          ],
        },
        {
          id: "D.4",
          label: "D.4",
          question:
            "Is the kitchen well-ventilated, with a properly installed and functional exhaust fan?",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          fields: [],
        },
        {
          id: "D.5",
          label: "D.5",
          question:
            "Is there a schedule for periodic deep cleaning of the entire canteen (kitchen plus dining area) and recorded in housekeeping checklist? ",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          helperText: "(Deep cleaning is needed weekly that includes cleaning of wall tiles /slabs, ceiling, cobweb, doors and window cleaning and furniture cleaning etc.). If record is maintained and updated daily, assign YES",
          fields: [
            {
              id: "photo",
              type: "file",
              label: "Capture or upload photo",
              accept: "image/*",
              capture: "environment",
              showWhen: ["yes"],
            },
          ],
        },
        {
          id: "D.6",
          label: "D.6",
          question:
            "Is the store area for raw materials (rice, vegetables, etc.) properly maintained, deep cleaned and recorded in housekeeping checklist?",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          helperText: "Deep cleaning of store room is needed every week. If housekeeping checklist maintained and updated daily, assign YES",
          fields: [
            {
              id: "photo",
              type: "file",
              label: "Capture or upload photo",
              accept: "image/*",
              capture: "environment",
              showWhen: ["yes"],
            },
          ],
        },
        {
          id: "D.7",
          label: "D.7",
          question:
            "Is LPG used as the primary fuel for cooking? Please be ensured that no smoke chulha is used inside the kitchen?",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          fields: [],
        },
        {
          id: "D.8",
          label: "D.8",
          question: "How would you rate the overall cleanliness of the kitchen and dining area",
          type: "radio",
          options: [
            { label: "Good", value: "good" },
            { label: "Satisfactory", value: "satisfactory" },
            { label: "Poor", value: "poor" },
          ],
          fields: [],
        },
      ],
    },

    {
      id: "e",
      title: "Safety Arrangements (E)",
      questions: [
        {
          id: "E.1",
          label: "E.1",
          question: "Is a fire extinguisher installed and functional in the kitchen?",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          helperText:
            "Mention the last refill date and upload the picture of the extinguisher with refill date clearly marked for verification",
          fields: [
            {
              id: "date",
              type: "date",
              label: "Last refill date",
              showWhen: ["yes"],
            },
            {
              id: "photo",
              type: "file",
              label: "Capture or upload photo",
              accept: "image/*",
              capture: "environment",
              showWhen: ["yes"],
            },
          ],
        },
        {
          id: "E.2",
          label: "E.2",
          question:
            "Does the first-aid box contain essential items such as disinfectants for cuts and burns, along with other necessary medicines required for addressing kitchen-related injuries?",
          type: "radio",
          helperText: "Check the expiry dates of all medicines",
          isHelperHighlight: true,
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          fields: [],
        },
        {
          id: "E.3",
          label: "E.3",
          question: "Are all staff trained on fire safety & mock drills?",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          fields: [],
        },
      ],
    },

    {
      id: "f",
      title: "Sanitation and Cleanliness (F)",
      questions: [
        {
          id: "F.1",
          label: "F.1",
          question:
            "Does canteen has a functional toilet for canteen staff? ",
          helperText: "Functionality of toilet means availability of running water for flushing and cleaning, non-choking toilet pans and urinals, functional cisterns, washbasin with soap and water for handwash and proper drainage system",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          fields: [],
        },
        {
          id: "F.2",
          label: "F.2",
          question: "Are the toilets well ventilated, illuminated and maintain privacy?",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          fields: [],
        },
        {
          id: "F.3",
          label: "F.3",
          question:
            "Are the toilets cleaned everyday and recorded in housekeeping checklist? (Check the housekeeping checklist and if updated daily, assign YES)",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          helperText: "Upload the current month's housekeeping record for verification",
          fields: [
            {
              id: "photo",
              type: "file",
              label: "Capture or upload photo",
              accept: "image/*",
              capture: "environment",
              showWhen: ["yes"],
            },
          ],
        },
        {
          id: "F.4",
          label: "F.4",
          question: "Is there a covered dustbin in canteen staff's toilet for disposal of sanitary waste?.",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          helperText: "Upload a picture of the dustbin inside the toilet",
          fields: [
            {
              id: "photo",
              type: "file",
              label: "Capture or upload photo",
              accept: "image/*",
              capture: "environment",
              showWhen: ["yes"],
            },
          ],
        },
        {
          id: "F.5",
          label: "F.5",
          question: "Is there a covered drainage system around canteen?",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          fields: [],
        },
        {
          id: "F.6",
          label: "F.6",
          question: "Are the cleaning materials (mopping cloth, broom, duster, wiper etc.) not stored in toilets?",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          fields: [],
        },
        {
          id: "F.7",
          label: "F.7",
          question:
            "Does the staff cleans the cooking/dining area before and after use and uses 2-bucket system with disinfectant (phenyl/lizol etc) for floor mopping?",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          helperText: "Upload a picture of the cleaning staff using 2 bucket system for floor mopping",
          fields: [
            {
              id: "photo",
              type: "file",
              label: "Capture or upload photo",
              accept: "image/*",
              capture: "environment",
              showWhen: ["yes"],
            },
          ],
        },
        {
          id: "F.8",
          label: "F.8",
          question:
            "Are regular pest control measures (every 3-4 months) conducted in the kitchen and store area? (Check and verify pest control record)",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          helperText: "Mention the last date of pest control activity and upload the record for verification",
          fields: [
            {
              id: "date",
              type: "date",
              label: "Last pest control date",
              showWhen: ["yes"],
            },
            {
              id: "photo",
              type: "file",
              label: "Capture or upload photo",
              accept: "image/*",
              capture: "environment",
              showWhen: ["yes"],
            },
          ],
        },
      ],
    },

    {
      id: "g",
      title: "Waste Management (G)",
      questions: [
        {
          id: "G.1",
          label: "G.1",
          question:
            "Waste segregation system (dry & wet waste) at all points along with covered, foot-operated bins",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          fields: [],
        },
        {
          id: "G.2",
          label: "G.2",
          question: "Whether IEC on waste segregation is displayed near the waste bins?",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          helperText: "Upload the picture for verification",
          fields: [
            {
              id: "photo",
              type: "file",
              label: "Capture or upload photo",
              accept: "image/*",
              capture: "environment",
              showWhen: ["yes"],
            },
          ],
        },
        {
          id: "G.3",
          label: "G.3",
          question:
            "Waste bins cleaned everyday after emptying the waste and recorded in housekeeping checklist. (Check the housekeeping checklist, if record is up to date, assign YES)",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          helperText: "Upload the housekeeping checklist record for verification",
          fields: [
            {
              id: "photo",
              type: "file",
              label: "Capture or upload photo",
              accept: "image/*",
              capture: "environment",
              showWhen: ["yes"],
            },
          ],
        },
        {
          id: "G.4",
          label: "G.4",
          question: "Is single-use plastic being used in the canteen?",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          fields: [],
        },
      ],
    },

    {
      id: "h",
      title: "Personal Hygiene (H)",
      questions: [
        {
          id: "H.1",
          label: "H.1",
          question:
            "Do the staff should wear appropriate protective gear in canteen? i. apron and cap while cutting vegetables & washing utensils ii. apron, cap and mask while cooking iii. apron, cap, mask and food handling gloves during serving food iv. apron and utility gloves while cleaning and mopping kitchen and its surroundings",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          helperText: "Upload the picture of staff wearing PPE while doing activities.",
          fields: [
            {
              id: "photo",
              type: "file",
              label: "Capture or upload photo",
              accept: "image/*",
              capture: "environment",
              showWhen: ["yes"],
            },
          ],
        },
        {
          id: "H.2",
          label: "H.2",
          question: "Are the staff trained & practice 6 steps of handwashing? (* Observe the 6 steps of hand washing)",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          fields: [],
        },
        {
          id: "H.3",
          label: "H.3",
          question:
            "Are half-yearly health check-ups conducted for the staff, and are the records properly maintained? (Half yearly health check-ups for staff and maintain record)",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          helperText: "Mention the last date of health check-up and upload the records for verification",
          fields: [
            {
              id: "date",
              type: "date",
              label: "Last health check-up date",
              showWhen: ["yes"],
            },
            {
              id: "photo",
              type: "file",
              label: "Capture or upload photo",
              accept: "image/*",
              capture: "environment",
              showWhen: ["yes"],
            },
          ],
        },
        {
          id: "H.4",
          label: "H.4",
          question: "Do the staff maintain personal hygiene (no nail polish, trimmed nails, covered hair, etc.)",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          fields: [],
        },
      ],
    },

    {
      id: "i",
      title: "Food Hygiene (I)",
      questions: [
        {
          id: "I.1",
          label: "I.1",
          question: "What type of plates are used for serving food to the beneficiaries?",
          type: "radio",
          options: [
            { label: "Thermocol plates", value: "thermocol_plates" },
            { label: "Aluminium foil plates", value: "aluminium_foil_plates" },
            { label: "Steel plates", value: "steel_plates" },
            { label: "Plastic plates", value: "plastic_plates" },
            { label: "Other", value: "other" },
          ],
          fields: [
            {
              id: "remark",
              type: "textarea",
              label: "Remarks",
              placeholder: "Enter remarks",
              showWhen: ["other"],
            },
          ],
        },
      ],
    },

    {
      id: "j",
      title: "IEC & Monitoring (J)",
      questions: [
        {
          id: "J.1",
          label: "J.1",
          question: "Are the posters on handwashing, safe toilet use, etc. displayed in the canteen?",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          fields: [],
        },
        {
          id: "J.2",
          label: "J.2",
          question: "Whether regular Online Entry being done in Online Portal?",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          fields: [],
        },
        {
          id: "J.3",
          label: "J.3",
          question: "Whether Daily entry being reconciled with Number of Coupon distributed ?",
          type: "radio",
          options: [
            { label: "YES", value: "yes" },
            { label: "NO", value: "no" },
          ],
          fields: [],
        },
      ],
    },

    {
      id: "k",
      title: "Challenges & Suggestion",
      questions: [
        {
          id: "challenge_1",
          label: "1",
          question: "Challenges (If Any)",
          type: "textarea",
          options: [],
          helperText: "",
          fields: [],
        },
        {
          id: "suggestion_1",
          label: "2",
          question: "Suggestions (If Any)",
          type: "textarea",
          options: [],
          helperText: "",
          fields: [],
        },
      ],
    },
  ],
};

export default kitchenDiningSurveyForm;